import type { QueryState } from 'enable-ui';

export const setUrlParams = (queryState: QueryState) => {
  const url = new URL(window.location.href);

  const params = Object.entries(queryState).map(([key, value]) => {
    return { key, value: String(value ?? '') };
  });

  params.forEach(({ key, value }) => {
    if (value) {
      url.searchParams.set(key, value);
    } else {
      url.searchParams.delete(key);
    }
  });

  window.history.pushState(null, '', url.toString());
};
